<ng-container xMeta metaTitle="Subscription Successful"></ng-container>

<x-shop-layout>
  <x-shop-header>
    <x-header-layout containerSize="container-full">
      <x-brand-logo xHeading xGoHomeLink></x-brand-logo>
    </x-header-layout>
  </x-shop-header>

  <div xBody class="container-fluid container-lg g-0 g-lg-4">
    <div class="col-lg-5 subscriber-success p-3 p-lg-3" *ngIf="subscriber$ | async as subscriber">
      <div class="icon-status success">
        <fa-icon icon="check"></fa-icon>
      </div>

      <h2 i18n="@@Page.SubscriberSuccess.OrderSuccessful.Title">Subscription activated</h2>

      <div class="info">
        <p>
          <ng-container i18n="@@Page.SubscriberSuccess.Confirmation.Title">
            Thank you for shopping with us.
          </ng-container>
          <br />
          <ng-container i18n="@@Page.SubscriberSuccess.Confirmation.Note">
            We’ll email you an confirmation with the details of your subscription.
          </ng-container>
        </p>
      </div>

      <section class="delivery-detail mat-caption" *ngIf="subscriber.shippingAddress">
        <div class="detail">
          <span>
            <ng-container i18n="@@Delivery.ShippingTo">Shipping to</ng-container>
            :
          </span>
          {{ subscriber.shippingAddress | shopAddress }}
        </div>
      </section>

      <section class="subscription-detail mat-caption">
        <div class="detail">
          <span>
            <ng-container i18n="@@Common.Name">Name</ng-container>
            :
          </span>
          {{ subscriber.variantName }}
        </div>
        <div class="detail">
          <span>
            <ng-container i18n="@@Time.Interval">Interval</ng-container>
            :
          </span>
          {{ subscriber.variantInterval }}
        </div>
      </section>

      <button
        mat-flat-button
        color="primary"
        xButtonSize="full"
        xGoHomeLink
        (click)="backToShopping()"
        i18n="@@CallToAction.ContinueShopping"
      >
        Continue Shopping
      </button>

      <a mat-button xButtonType="link" xNeedHelp color="primary" i18n="@@CallToAction.NeedHelp">
        Need Help?
      </a>
    </div>
  </div>
</x-shop-layout>
